'use client'

import { useEffect } from 'react'
import { logger } from '@/app/utilities/logger'

export default function GlobalLogger() {
    useEffect(() => {
        const handleError = (event: ErrorEvent) => {
            logger.error('Unhandled Error', event.error || event.message)
        }

        const handleRejection = (event: PromiseRejectionEvent) => {
            logger.error('Unhandled Promise Rejection', event.reason)
        }

        window.addEventListener('error', handleError)
        window.addEventListener('unhandledrejection', handleRejection)

        return () => {
            window.removeEventListener('error', handleError)
            window.removeEventListener('unhandledrejection', handleRejection)
        }
    }, [])

    return null
}
